<template>
    <div class="mainbox">
        <div class="err">4</div>
        <i class="far fa-question-circle fa-spin"></i>
        <div class="err2">4</div>
        <div class="msg">
            Maybe this page moved? Got deleted? Is hiding out in quarantine? Never existed in the first
            place?<p>Let's go <router-link to="/">home</router-link> and try from there.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Notfound",
        mounted() {
        }
    }
</script>

<style scoped lang="scss">
    @import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@600;900&display=swap");


    body {
        background-color: whitesmoke !important;
    }


    .mainbox {
        background-color: whitesmoke;
        margin: auto;
        height: 600px;
        width: 600px;
        position: relative;
        padding-top: 100px;
    }

    .err {
        color: #000;
        font-family: 'Nunito Sans', sans-serif;
        font-size: 11rem;
        position: absolute;
        left: 20%;
        top: 8%;
    }

    .far {
        position: absolute;
        font-size: 8.5rem;
        left: 42%;
        top: 18%;
        color: #000;
    }

    .err2 {
        color: #000;
        font-family: 'Nunito Sans', sans-serif;
        font-size: 11rem;
        position: absolute;
        left: 68%;
        top: 8%;
    }

    .msg {
        text-align: center;
        font-family: 'Nunito Sans', sans-serif;
        font-size: 1.6rem;
        position: absolute;
        left: 16%;
        top: 45%;
        width: 75%;
    }

    a {
        text-decoration: none;
        color: black;
    }

    a:hover {
        text-decoration: underline;
    }
</style>
